import { render, staticRenderFns } from "./RecentNews.vue?vue&type=template&id=cc307174&scoped=true&"
import script from "./RecentNews.vue?vue&type=script&lang=js&"
export * from "./RecentNews.vue?vue&type=script&lang=js&"
import style0 from "./RecentNews.vue?vue&type=style&index=0&id=cc307174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc307174",
  null
  
)

export default component.exports